import { BaseModel } from './base';
import { Damage } from './damage';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export interface VehicleSummary {
    plate_number: string;
    vin: string;
    trans: { plate_number: string, vin: string };
}

export class Vehicle extends BaseModel
                     implements VehicleSummary {
    public comment: string;
    public damage: Damage;
    public first_registration: Date;
    public kba_manufacturer: string;
    public kba_type: string;
    public location: string;
    public manufacturer: string;
    public mileage_comment: string;
    public mileage_read: number;
    public mileage_read_unit_code: string;
    public mileage_read_unit_value: string;
    public mileage_specified: number;
    public mileage_specified_unit_code: string;
    public mileage_specified_unit_value: string;
    public mileage_estimated: number;
    public mileage_estimated_unit_code: string;
    public mileage_estimated_unit_value: string;
    public model: string;
    public plate_number: string;
    public submodel: string;
    public type: string;
    public vin: string;

    public readonly trans = {
        plate_number: marker('vehicle.plate_number'),
        first_registration: marker('vehicle.first_registration'),
        vin: marker('vehicle.vin'),
        vin_check: marker('vehicle.vin_check'),
        kba_manufacturer: marker('vehicle.kba_manufacturer'),
        kba_type: marker('vehicle.kba_type'),
        location: marker('vehicle.location'),
        type: marker('vehicle.type'),
        manufacturer: marker('vehicle.manufacturer'),
        mileage: marker('vehicle.mileage.mileage'),
        model: marker('vehicle.model'),
        submodel: marker('vehicle.submodel'),
        comment: marker('vehicle.comment')
    };

    constructor(json?: any) {
        super(json);
    }
 
    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            first_registration: json && json.first_registration ? new Date(json.first_registration) : null,
            damage: new Damage(json && json.damage),
            type: json && json.type || '',
            manufacturer: json && json.manufacturer || ''
        });
    }
}
